import { render, staticRenderFns } from "./LocationsSaltLakeCity.vue?vue&type=template&id=18aef364&lang=pug&"
import script from "./LocationsSaltLakeCity.vue?vue&type=script&lang=ts&"
export * from "./LocationsSaltLakeCity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports